import '../gdpr-banner';

export default (ctx, html) => html`
  <div class="${ctx.headerOverlay? 'show-overlay': ''}"><slot name="page-header"></slot></div>
  <div class="${ctx['full-height']? 'full-height': ''} ${ctx.contentOverlay? 'show-overlay': ''}"><slot name="page-content"></slot></div>
  <div class="${ctx.footerOverlay? 'show-overlay': ''}"><slot name="page-footer"></slot></div>
  <gdpr-banner></gdpr-banner>
`;
